import { render, staticRenderFns } from "./ProductDropDownLeftPanel.vue?vue&type=template&id=fb0be46e&scoped=true"
import script from "./ProductDropDownLeftPanel.vue?vue&type=script&lang=js"
export * from "./ProductDropDownLeftPanel.vue?vue&type=script&lang=js"
import style0 from "./ProductDropDownLeftPanel.vue?vue&type=style&index=0&id=fb0be46e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb0be46e",
  null
  
)

export default component.exports